import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { BUTTON_WITH_ARROW_BACKGROUND_TYPE } from "../../../../../../lib/typography/buttonWithArrowConstants";
import SquaberLink from "../../../SquaberLink";
import ChevronRight from "../../../StockPageHeader/components/StockAnalysisButton/assets/chevron-right.svg";

const getClassName = ({
  withBackground,
  backgroundType,
  showArrow,
  className
}) =>
  classNames(
    "inline-flex",
    "align-center",
    showArrow && "gap-2",
    "font-semibold",
    "text-sm",
    "text-black",
    "line-height-100",
    "cursor-pointer",
    "b-none",
    "shrink-0",
    "no-underline",
    "focus-visible:outline-link",
    "disabled:opacity-45",
    "justify-center",
    withBackground
      ? [
          "button-4",
          "p-3 md:p-4",
          backgroundType === BUTTON_WITH_ARROW_BACKGROUND_TYPE.GRAY &&
            "button-4_gray"
        ]
      : ["py-3", "bg-none", "hover:opacity-85"],
    className
  );

const ButtonWithArrowContent = ({ children, showArrow }) => (
  <>
    <span>{children}</span>
    {showArrow ? (
      <img
        src={ChevronRight}
        alt=""
        width={14}
        height={14}
        className="shrink-0"
        aria-hidden
      />
    ) : null}
  </>
);

const ButtonWithArrow = ({
  children,
  href,
  withBackground = true,
  backgroundType = BUTTON_WITH_ARROW_BACKGROUND_TYPE.YELLOW,
  showArrow = true,
  fontSize,
  className,
  disabled,
  type = "button",
  target,
  onClick,
  ...rest
}) => {
  const sharedClassName = getClassName({
    withBackground,
    backgroundType,
    showArrow,
    className
  });
  const style = fontSize != null ? { fontSize } : undefined;

  if (href) {
    return (
      <SquaberLink
        to={href}
        target={target}
        className={sharedClassName}
        style={style}
        aria-disabled={disabled || undefined}
        onClick={
          disabled
            ? event => {
                event.preventDefault();
              }
            : onClick
        }
        {...rest}
      >
        <ButtonWithArrowContent showArrow={showArrow}>
          {children}
        </ButtonWithArrowContent>
      </SquaberLink>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      className={sharedClassName}
      style={style}
      onClick={onClick}
      {...rest}
    >
      <ButtonWithArrowContent showArrow={showArrow}>
        {children}
      </ButtonWithArrowContent>
    </button>
  );
};

ButtonWithArrow.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  withBackground: PropTypes.bool,
  backgroundType: PropTypes.oneOf(
    Object.values(BUTTON_WITH_ARROW_BACKGROUND_TYPE)
  ),
  showArrow: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  target: PropTypes.string,
  onClick: PropTypes.func
};

export default ButtonWithArrow;
